import React, { Component } from "react"
import "./Simulator.css"
import animation from "../autogen/simulator-web.pde"

/**
 * Drop Machine simulator component. Based on the rain_circle_simulator written
 * in Processing.
 *
 * @class      Simulator (name)
 */
class Simulator extends Component {
  constructor(props) {
    super(props)
    this.state = { pattern: -1, patternFn: props.patternFn }
  }

  render() {
    return (
      <div className="Simulator-container">
        <canvas
          id="animation"
          className="Simulator-canvas"
          data-processing-sources={animation}
        ></canvas>
      </div>
    )
  }

  /**
   * Sets given pattern. In case the pattern in the same as previously active
   * pattern, does nothing. Otherwise sets the new pattern to start with a small
   * delay.
   *
   * @param      {<object>}  simulator  The simulator element
   */
  setPatternIfNeeded(simulator) {
    let newPattern = this.state.patternFn()
    if (this.state.pattern === newPattern) {
      return
    }

    simulator.signalSetPattern(this.state.patternFn(), 30)
    this.setState({ pattern: newPattern })
  }

  componentDidUpdate(prevProps, prevState) {
    let simulator = window.Processing.getInstanceById("animation")
    if (typeof simulator === "undefined") {
      return
    }

    this.setPatternIfNeeded(simulator)
  }

  componentDidMount() {
    // The initial pattern needs to be set only after Processing has
    // initialized. I have no idea how to hook the action to it properly, so
    // here is a rough timer loop for it.
    let intervalId = setInterval(() => {
      let simulator = window.Processing.getInstanceById("animation")
      if (typeof simulator === "undefined") {
        return
      }

      this.setPatternIfNeeded(simulator)

      clearInterval(intervalId)
    }, 100)
  }
}

export default Simulator



// WEBPACK FOOTER //
// ./src/components/Simulator.js